export enum AlertType {
  Primary,
  Success,
  Error,
  Info,
  Warning
}
